module.exports = __webpack_public_path__ + "img/member-original.51fdec60.png";